import Headroom from "headroom.js";
const nav = document.getElementById("mainNav");
const element = document.querySelector("body");
const options = {
	tolerance: {
		up: 1,
		down: 500,
	},
	onNotTop: function () {
		if (element.classList.contains("pictorial")) {
			nav.classList.remove("navbar-dark");
			nav.classList.add("navbar-light");
		}
	},
	onTop: function () {
		if (element.classList.contains("pictorial")) {
			nav.classList.remove("navbar-light");
			nav.classList.add("navbar-dark");
		}
	},
};

const headroom = new Headroom(element, options);
headroom.init();
